/* ============================================================
   <collection-intro> — mobile-first disclosure for the collection
   description. Progressive enhancement: the server always renders
   the full translated description (crawlable, no content removed);
   this element clamps it visually and reveals an accessible
   Show more / Show less toggle only when the text overflows.

   Host modifier classes (set by Liquid from section settings):
     .collection-intro--clamp-mobile   clamp under 768px
     .collection-intro--clamp-desktop  clamp at 768px and up
   ============================================================ */
(function () {
  'use strict';

  if (customElements.get('collection-intro')) return;

  var MOBILE = window.matchMedia('(max-width: 767px)');

  class CollectionIntro extends HTMLElement {
    connectedCallback() {
      this.body = this.querySelector('.collection-intro__body');
      this.toggle = this.querySelector('.collection-intro__toggle');
      if (!this.body || !this.toggle) return;
      this.expanded = false;
      this.clampMobile = this.classList.contains('collection-intro--clamp-mobile');
      this.clampDesktop = this.classList.contains('collection-intro--clamp-desktop');

      this.boundUpdate = this.update.bind(this);
      this.boundResize = this.debounce(this.boundUpdate, 150);
      this.toggle.addEventListener('click', this.onToggle.bind(this));
      MOBILE.addEventListener('change', this.boundUpdate);
      window.addEventListener('resize', this.boundResize);
      this.update();
    }

    disconnectedCallback() {
      MOBILE.removeEventListener('change', this.boundUpdate);
      window.removeEventListener('resize', this.boundResize);
    }

    debounce(fn, wait) {
      var timer;
      return function () {
        clearTimeout(timer);
        timer = setTimeout(fn, wait);
      };
    }

    shouldClamp() {
      return MOBILE.matches ? this.clampMobile : this.clampDesktop;
    }

    update() {
      if (!this.shouldClamp()) {
        this.expanded = false;
        this.classList.remove('is-expanded');
        this.applyState(false);
        return;
      }
      this.applyState(!this.expanded);
    }

    applyState(clamped) {
      this.classList.toggle('is-clamped', clamped);
      var overflowing = clamped && this.body.scrollHeight > this.body.clientHeight + 1;
      this.classList.toggle('has-overflow', overflowing);
      this.toggle.hidden = !(overflowing || this.expanded);
      this.toggle.setAttribute('aria-expanded', this.expanded ? 'true' : 'false');
    }

    onToggle() {
      this.expanded = !this.expanded;
      this.classList.toggle('is-expanded', this.expanded);
      this.update();
      if (!this.expanded && this.getBoundingClientRect().top < 0) {
        this.scrollIntoView({ block: 'start' });
      }
    }
  }

  customElements.define('collection-intro', CollectionIntro);
})();
